module.exports = __webpack_public_path__ + "static/img/center01.84ecb3d5.png";